const caseValues = (forSlope, forSpeedLimit, forCurvature, unknown) => {
    return [
        'case',
        ['==', ['get', 'type'], 'Slope'],
        forSlope,
        ['==', ['get', 'type'], 'SpeedLimit'],
        forSpeedLimit,
        ['==', ['get', 'type'], 'Curvature'],
        forCurvature,
        unknown
    ]
}

const layers = [
    {
        'id': 'EnhancedData/Edges',
        'source': 'EnhancedData',
        'type': 'line',
        'layout': {
            'line-join': 'round',
            'line-cap': 'round'
        },
        'filter': ['==', '$type', 'LineString'],
        'paint': {
            'line-color': '#EDD28B',
            'line-width': 2
        }
    },
    {
        'id': 'EnhancedData/Edges:Highlighted:Slope',
        'source': 'EnhancedData',
        'type': 'line',
        'layout': {
            'line-join': 'round',
            'line-cap': 'round'
        },
        'filter': ['in', 'uuid', ''],
        'paint': {
            'line-color': '#5CD79A',
            'line-width': 4
        }
    },
    {
        'id': 'EnhancedData/Edges:Highlighted:SpeedLimit',
        'source': 'EnhancedData',
        'type': 'line',
        'layout': {
            'line-join': 'round',
            'line-cap': 'round'
        },
        'filter': ['in', 'uuid', ''],
        'paint': {
            'line-color': '#F78475',
            'line-width': 4
        }
    },
    {
        'id': 'EnhancedData/Edges:Highlighted:Curvature',
        'source': 'EnhancedData',
        'type': 'line',
        'layout': {
            'line-join': 'round',
            'line-cap': 'round'
        },
        'filter': ['in', 'uuid', ''],
        'paint': {
            'line-color': '#98CAFF',
            'line-width': 4
        }
    },
    {
        'id': 'EnhancedData/Points',
        'source': 'EnhancedData',
        'type': 'symbol',
        'filter': ['==', '$type', 'Point'],
        'layout': {
            'icon-image': caseValues('slope', 'speed-limit', 'curve', 'custom-marker'),
            'icon-size': 0.5
        }
    }
];

export default layers;